import apiRequestCommon from './index'
import config from '@/v2/config'

export default {
  path: '/v1/users',
  async delete (authId, tsid, otoken, usedDtwash, usedMaintePack, maintePackSsCode, appVersion) {
    await window.callNativeHTTPX()
    let headersParam = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'X-CLS-App-Version': appVersion
    }
    const body = {
      tsid,
      otoken,
      used_dtwash: usedDtwash,
      used_maintenance_pack: usedMaintePack
    }
    if (maintePackSsCode) body.maintenance_pack_ss_code = maintePackSsCode
    // ローカルは認証情報を参照しないように変更する
    if (process.env.VUE_APP_LOCAL === 'true') {
      headersParam = config.API_AUTH_HEADERS_PARAM
      headersParam['X-CLS-App-Version'] = config.API_HEADERS_PARAM.X_CLS_App_Version
    }

    let delApiPath
    if (authId === null) {
      delApiPath = `${this.path}/`
    } else {
      delApiPath = `${this.path}/${authId}`
    }

    return apiRequestCommon.delete(delApiPath, {
      data: body,
      headers: headersParam
    })
  }
}
